$(document).ready(function () {

    if ($('.portadas').length > 0) {
        var portadas = document.querySelector('.portadas');
        // portadas.classList.remove('hidden');
        // portadas.offsetHeight;

        var options = {
            cellSelector: '.slide-cell',
            pageDots: true,
            percentPosition: false,
            lazyLoad: true,
            wrapAround: true,
            setGallerySize: true,
            autoPlay: 6000,
            imagesLoaded: true,
            pauseAutoPlayOnHover: false,
            adaptiveHeight: true,
            resize: true,

            on: {
                ready: function ready() {
                    $('.wo-slide-overlay').fadeOut('slow', function () {
                        portadas.resize();
                    });

                    this.resize();
                }
            }
        };

        portadas = new Gallery('.portadas', options);
        // Arregla el bug del margen
        portadas.on('settle', function () {
            portadas.resize();
        });

        $(window).resize(function () {
            // if ( matchMedia('screen and (max-width: 992px)').matches ) {
            //     portadas.options.setGallerySize = true;
            //     $('.sad-slide > .flickity-viewport').css({'height':'100%'});
            //
            // }
            //
            // if ( matchMedia('screen and (min-width: 992px)').matches ) {
            //     portadas.options.setGallerySize = false;
            //     $('.sad-slide > .flickity-viewport').css({'height':'100%'});
            // }
            portadas.resize();
        });

        // if ( matchMedia('screen and (max-width: 992px)').matches ) {
        //     portadas.options.setGallerySize = true;
        //     portadas.resize();
        // }

    }
});


//////////////////
// WEBPACK FOOTER
// ./resources/assets/page_assets/js/sad-page-globals.js
// module id = 41
// module chunks = 0